import { useQuery } from "react-query";
import { quizAttemptsApi } from "@/react/api/quizAttemptsApi";
import type { QuizAttempt } from "@/react/types/QuizAttempt";

interface UseGetQuizAttemptForAdminProps {
  attemptId: number;
  quizId: number;
}
export const useGetQuizAttemptForAdmin = ({
  quizId,
  attemptId,
}: UseGetQuizAttemptForAdminProps) => {
  const isForAdminReview = true;
  return useQuery<QuizAttempt>({
    queryKey: ["attempt", quizId, attemptId, isForAdminReview],
    queryFn: () =>
      quizAttemptsApi.show({
        quizId: quizId,
        id: attemptId,
        isForAdminReview: true,
      }),
  });
};
